import axios from 'axios'
import md5 from 'js-md5'
import i18n from '@/lang'
import { message } from 'element-ui'
import { getLocal } from '@/libs/storage'
import { failMsg } from '@/libs/utils'
import store from '@/store'
import router from '@/router'
import Cookies from 'js-cookie'
import config from '@/api/config'

const axiosServe = axios.create({
    baseURL: config.baseUrl,
    timeout: config.timeout,
})
// 添加请求拦截器
axiosServe.interceptors.request.use(
    function (config) {
        // 在发送请求之前做些什么
        return config
    },
    function (error) {
        // 对请求错误做些什么
        return Promise.reject(error)
    },
)

// 添加响应拦截器
axiosServe.interceptors.response.use(
    // 成功
    function (response) {
        // 对响应数据做点什么
        if (response.data.result) {
            return response.data
        } else {
            if (
                response.data.msg.indexOf('登录信息已过期') != -1 ||
                response.data.msg.indexOf('login information has expired') != -1
            ) {
                router.push(`/${i18n.locale}/home`)
                store.commit('login/LOGOUT')
                // failMsg(error);
            }
            // failMsg(response.data.msg)
            return Promise.reject(response.data.msg)
        }
    },
    // 失败
    function (error) {
        const status = (error.response && error.response.status && error.response.status) || ''
        if (error.code == 'ECONNABORTED' && error.message.indexOf('timeout') != -1) {
            return Promise.reject(config.errMsg['timeout'])
        }
        if (status === 404) {
            failMsg(config.errMsg['404'])
            return Promise.reject(config.errMsg['404'])
        }

        if (status === 500) {
            message(config.errMsg['500'])
            return Promise.reject(config.errMsg['500'])
        }
        message(config.errMsg['UnKnown'])
        return new Promise.reject(config.errMsg['UnKnown'])
    },
)

/*
 * 获取随机数32位
 * */
function getrandom() {
    let chars = [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
    ]
    let nums = ''
    for (let i = 0; i < 32; i++) {
        let id = parseInt(Math.random() * 61)
        nums += chars[id]
    }
    return nums
}
function getStorage(name) {
    if (!name) return
    return window.localStorage.getItem(name) || ''
}
function setStorage(name, content) {
    if (!name) return
    if (typeof content !== 'string') {
        content = JSON.stringify(content)
    }
    window.localStorage.setItem(name, content)
}

function objKeySort(obj) {
    //排序的函数
    let newkey = Object.keys(obj).sort()
    //先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
    let newObj = {} //创建一个新的对象，用于存放排好序的键值对
    for (let i = 0; i < newkey.length; i++) {
        //遍历newkey数组
        newObj[newkey[i]] = obj[newkey[i]] //向新创建的对象中按照排好的顺序依次增加键值对
    }
    return newObj //返回排好序的新对象
}

const request = options => {
    if (!options.data) {
        options.data = {}
    }

    var sign = ''
    let requestId = getrandom() // 随机数获取 requestId
    let appId = config.appId
    let appKey = config.appKey
    getStorage('_udid') ? getStorage('_udid') : setStorage('_udid', getrandom())
    let udid = getStorage('_udid') // 随机数获取 udid
    options.data.requestId = requestId
    options.data.udid = udid
    options.data.appId = appId
    options.data.userId = store.state.login.userId
    options.data.token = store.state.login.token
    options.data.source = Cookies.get('orderSourceId') ? Cookies.get('orderSourceId') : ''
    if (i18n.locale == 'chinese') {
        options.data.languageType = 1
    } else {
        options.data.languageType = 2
    }
    // 在生成签名(sign)之前对需要提交的参数进行一次排序
    options.data = objKeySort(options.data)
    if (typeof options.data == 'object') {
        var str = ''
        //拼接字符串
        for (var key in options.data) {
            if (options.data[key] !== '' && options.data[key] !== undefined) {
                str += key + '=' + options.data[key] + '&'
            }
        }
        //md5加密
        if (str !== '') {
            str = str + 'appKey=' + appKey
            //md5加密 获取验签
            sign = md5(str)
        }
        options.data.sign = sign
    }
    return axiosServe(options)
}

export default request
